// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__10zan","content":"LayoutSettings_content__c4XsL"};